import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { annotation as annotationSelectors } from './../selectors';
import ArtifactHealthComponent from './../Components/ArtifactHealthComponent.jsx';
import { fetchArtifactHealthPlatformStatuses, annotations } from './../actions';

// The number of days to look back for records
export const ANNOTATION_PERIOD = 365;

export class ArtifactHealthContainer extends Component {
  static propTypes = {
    fetchArtifactHealthPlatformStatuses: PropTypes.func.isRequired,
    fetchAppAnnotations: PropTypes.func.isRequired,
    annotations: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.props.fetchArtifactHealthPlatformStatuses();
    this.props.fetchAppAnnotations(ANNOTATION_PERIOD);
  }
  componentDidUpdate() {
    this.props.fetchAppAnnotations(ANNOTATION_PERIOD);
  }

  render() {
    return (
      <ArtifactHealthComponent annotations={this.props.annotations} />
    );
  }
}

export const mapStateToProps = (state) => {
  const annotations = {
    ...annotationSelectors.getAnnotationsByScenarioIdsOrderByDate(state),
    ...annotationSelectors.getAnnotationsByAppIdsOrderByDate(state)
  };
  return { annotations };
};

export default connect(
  mapStateToProps,
  {
    fetchArtifactHealthPlatformStatuses,
    fetchAppAnnotations: annotations.fetchAppAnnotations
  }
)(ArtifactHealthContainer);


// WEBPACK FOOTER //
// src/Containers/ArtifactHealthContainer.jsx